import { useCallback, useEffect, useState } from 'react';
import { CHIME_RECORDER_SETTLE_MS, chimeRecordingShown, settleRecordingExpectation } from './chimeRecording';

/**
 * "Recording" for a call page, from the recorder's roster presence (Decision 39). `expect(true)` holds a server answer
 * (a join's `recordingActive`, a Resume) until the roster agrees or `holdMs` passes; `serverRecording` (the page's poll,
 * when it has one) keeps a slow-starting recorder from reading as "not recording" after that.
 */
export function useChimeRecordingShown(
  recorderPresent: boolean,
  serverRecording?: boolean,
  holdMs: number = CHIME_RECORDER_SETTLE_MS,
): {
  recording: boolean;
  expect: (value: boolean | undefined) => void;
} {
  const [expected, setExpected] = useState<boolean | undefined>();
  useEffect(() => {
    setExpected((current) => settleRecordingExpectation(current, recorderPresent));
  }, [expected, recorderPresent]);
  useEffect(() => {
    if (expected === undefined) return undefined;
    const timer = setTimeout(() => setExpected(undefined), holdMs);
    return () => clearTimeout(timer);
  }, [expected, holdMs]);
  const expect = useCallback((value: boolean | undefined) => setExpected(value), []);
  return { recording: chimeRecordingShown(recorderPresent, expected, serverRecording), expect };
}
